import { connect } from "react-redux";
import { clearAlerts } from "rivals/redux/alert/actions";
import { setIsRedirecting } from "rivals/redux/application/actions";
import { getIsRedirecting } from "rivals/redux/application/selectors";
import { isAuthenticated } from "rivals/redux/authentication/selectors";
import { sendGAEvent } from "rivals/redux/ga/actions";
import {
  getBillingInformationConstants,
  getIsSubscribable,
  getSelectedSite,
  getSubscriptionPricingConstants,
  selectTaxEstimationError
} from "rivals/redux/rails/selectors";
import { State } from "rivals/redux/reducer";
import { createAccount } from "rivals/redux/registration/actions";
import { getSentRegistrationParams } from "rivals/redux/registration/selectors";
import {
  resetPayPal,
  updatePayPalError,
  validateEmailOrUsername
} from "rivals/redux/user/actions";
import {
  getCurrentUser,
  getPayPalAddress,
  getPayPalBillingAgreement,
  getPayPalEmail,
  getPayPalError,
  getPayPalToken,
  getRegistrationsError,
  getSubmitting,
  getValidationErrors,
  isSubscribed
} from "rivals/redux/user/selectors";
import { StateProps } from "./types";
import Subscribe from ".";

const mapStateToProps = (state: State): StateProps => ({
  billingConstants: getBillingInformationConstants(state),
  currentSite: getSelectedSite(state),
  isAuthenticated: isAuthenticated(state),
  isRedirecting: getIsRedirecting(state),
  isSiteSubscribable: getIsSubscribable(state),
  isSubscribed: isSubscribed(state),
  payPalAddress: getPayPalAddress(state),
  payPalBillingAgreement: getPayPalBillingAgreement(state),
  payPalEmail: getPayPalEmail(state),
  payPalError: getPayPalError(state),
  payPalToken: getPayPalToken(state),
  pricingConstants: getSubscriptionPricingConstants(state),
  registrationError: getRegistrationsError(state),
  registrationParams: getSentRegistrationParams(state),
  submitting: getSubmitting(state),
  taxEstimationError: selectTaxEstimationError(state),
  user: getCurrentUser(state),
  validationError: getValidationErrors(state)
});

const mapDispatchToProps = {
  clearAlerts,
  createAccount,
  resetPayPal,
  sendGAEvent,
  setIsRedirecting,
  updatePayPalError,
  validateEmailOrUsername
};

export default connect(mapStateToProps, mapDispatchToProps)(Subscribe);
